import React from "react";
import mirchiLeft from "../resourcess/mirchi90.png";
import mirchiRight from "../resourcess/mirchi90+1.png";
import {
  FaBoxOpen,
  FaPhoneAlt,
  FaFileInvoice,
  FaCog,
  FaCheckCircle,
  FaGlobe,
  FaIndustry,
  FaRupeeSign,
  FaTruck,
  FaHandshake,
} from "react-icons/fa";

const WhyChoose = () => {
  return (
    <section className="section why-section">
      <img src={mirchiLeft} alt="" className="mirchi-decor mirchi-why-tl" aria-hidden="true" />
      <img src={mirchiRight} alt="" className="mirchi-decor mirchi-why-br" aria-hidden="true" />
      <div className="section-inner">
        <h2 className="section-heading">Why Choose us?</h2>
        <div className="why-grid">
          <article className="why-card">
            <div className="why-icon" aria-hidden="true">
              <FaGlobe />
            </div>
            <h3 className="why-title">Export Quality Standards</h3>
            <p className="why-copy">
              We maintain strict quality standards to meet global export requirements.
            </p>
          </article>
          <article className="why-card">
            <div className="why-icon" aria-hidden="true">
              <FaBoxOpen />
            </div>
            <h3 className="why-title">Consistent Bulk Supply</h3>
            <p className="why-copy">
              Reliable supply capacity to fulfill large and recurring orders.
            </p>
          </article>
          <article className="why-card">
            <div className="why-icon" aria-hidden="true">
              <FaRupeeSign />
            </div>
            <h3 className="why-title">Competitive Pricing</h3>
            <p className="why-copy">
              Direct sourcing ensures cost efficiency without compromising quality.
            </p>
          </article>
          <article className="why-card">
            <div className="why-icon" aria-hidden="true">
              <FaTruck />
            </div>
            <h3 className="why-title">Reliable Logistics</h3>
            <p className="why-copy">
              Smooth handling and timely delivery across domestic and international markets.
            </p>
          </article>
          <article className="why-card">
            <div className="why-icon" aria-hidden="true">
              <FaHandshake />
            </div>
            <h3 className="why-title">Trusted Partnerships</h3>
            <p className="why-copy">
              Building long-term relationships with clients through consistency and reliability.
            </p>
          </article>
          <article className="why-card">
            <div className="why-icon" aria-hidden="true">
              <FaIndustry />
            </div>
            <h3 className="why-title">Direct Market Sourcing</h3>
            <p className="why-copy">
              Sourcing directly from major markets for better quality control and pricing.
            </p>
          </article>
        </div>
        <div id="process" className="process-strip">
          <div className="process-step">
            <div className="process-icon" aria-hidden="true">
              <FaPhoneAlt />
            </div>
            <div className="process-label">Inquiry</div>
          </div>
          <div className="process-divider" />
          <div className="process-step">
            <div className="process-icon" aria-hidden="true">
              <FaFileInvoice />
            </div>
            <div className="process-label">Quotation</div>
          </div>
          <div className="process-divider" />
          <div className="process-step">
            <div className="process-icon" aria-hidden="true">
              <FaCog />
            </div>
            <div className="process-label">Processing</div>
          </div>
          <div className="process-divider" />
          <div className="process-step">
            <div className="process-icon" aria-hidden="true">
              <FaCheckCircle />
            </div>
            <div className="process-label">Quality Check</div>
          </div>
          <div className="process-divider" />
          <div className="process-step">
            <div className="process-icon" aria-hidden="true">
              <FaTruck />
            </div>
            <div className="process-label">Shipping</div>
          </div>
          <div className="process-divider" />
          <div className="process-step">
            <div className="process-icon" aria-hidden="true">
              <FaHandshake />
            </div>
            <div className="process-label">Delivery &amp; Support</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
